export default class FileUploader {
  constructor(fileInputId, selectedFilesId, filenameWrapperCssClass) {
    this.fileInput = document.querySelector(fileInputId);
    this.selectedFiles = document.querySelector(selectedFilesId);
    this.filenameWrapperCssClass = filenameWrapperCssClass.split(' ');
    this.init();
  }

  addFilenameToSelectedFiles(labelText = '') {
    const wrapper = document.createElement('div');
    wrapper.classList.add(...this.filenameWrapperCssClass);

    const label = document.createElement('span');
    label.innerText = labelText;

    wrapper.appendChild(label);
    selectedFiles.appendChild(wrapper);
  }

  // skipIndex prevents removing a node by its index (I.E. 'Files to upload')
  emptyFilenameList(skipIndex = 0) {
    [...selectedFiles.children].forEach(
      (child, index) => (
        index > skipIndex && selectedFiles.removeChild(child)
      )
    );
  }

  fileInputChangeHandler() {
    const files = [...this.fileInput.files];
    // Skip the node for the 'No files selected' message
    const skipIndex = files.length > 0 ? 0 : 1;
    this.emptyFilenameList(skipIndex);
    files.forEach(({ name }) => this.addFilenameToSelectedFiles(name));
  }

  init() {
    this.fileInput.addEventListener(
      'change', this.fileInputChangeHandler.bind(this)
    );

    this.fileInputChangeHandler();
  }
}
